import React from 'react';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import CollectionBlock from './CollectionBlock';
import s from './Collections.scss';
const Collections = ({ block, deviation: parentDeviation })=>{
    var _block_collections;
    return /*#__PURE__*/ React.createElement(SidebarBlockWrapper, {
        deviation: parentDeviation,
        block: block,
        headerClassName: s['header']
    }, /*#__PURE__*/ React.createElement("div", null, (_block_collections = block.collections) === null || _block_collections === void 0 ? void 0 : _block_collections.map(({ collection, deviations })=>collection && deviations && /*#__PURE__*/ React.createElement(CollectionBlock, {
            key: collection.folderId,
            parentDeviation: parentDeviation,
            collection: collection,
            deviations: deviations
        }))));
};
Collections.displayName = 'Collections';
export default Collections;

//# sourceMappingURL=Collections.js.map